import HttpService from './HttpService';

const URL_ORDENACAO = '/api/credores/Consumidor/Ordenacao';
const TIMEOUT_MS = 1500;

export interface OrdemDividaItem {
  credor: string;
  dividaId: number;
}

export interface OrdenacaoBackendResponse {
  ordemDividas: OrdemDividaItem[];
}

/**
 * Chama GET /consumidor/ordenacao. Timeout 150ms. Nunca propaga erro.
 * O retorno (quando 200) será persistido no futuro pelo DividasOrderingService.
 */
class OrdenacaoBackendService extends HttpService {
  async buscarOrdenacao(): Promise<OrdenacaoBackendResponse | null> {
    try {
      const data = await this.get<OrdenacaoBackendResponse>(URL_ORDENACAO, {
        timeout: TIMEOUT_MS,
      });
      if (!data?.ordemDividas || !Array.isArray(data.ordemDividas)
        || data.ordemDividas.length === 0) {
        return null;
      }
      return data;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('OrdenacaoBackendService: falha ao buscar ordenação (timeout/rede)', err);
      return null;
    }
  }
}

export default new OrdenacaoBackendService();
